<template>
  <div class="base-feature">
    <div class="base-feature__container">
      <div class="base-feature__container__head">
        <div class="base-feature__container__head__tabs">
          <div
            v-for="(feature, id) in features"
            :key="id"
            :class="id === tabActive ? `active${id}` : ''"
            class="base-feature__container__head__tabs__tab"
            @click="changeTab(id)"
          >
            <div
              class="base-feature__container__head__tabs__tab__title"
              :class="id === tabActive ? 'active' : ''"
            >
              {{ feature.feature }}
            </div>
          </div>
        </div>
      </div>
      <div class="base-feature__container__body">
        <Track v-if="tabActive === 0" />
        <Checkprice v-if="tabActive === 1" />
        <AgentLocation v-if="tabActive === 2" />
      </div>
    </div>
  </div>
</template>

<script>
import mixinMobile from '@/misc/mixinMobile';
import Track from "../components/track.vue";
import Checkprice from "../components/checkprice.vue";
import AgentLocation from "../components/agent-location.vue";

export default {
  name: "FeatureSectionHome",
  components: {
    Track,
    Checkprice,
    AgentLocation,
  },
  mixins: [mixinMobile],
  data() {
    return {
      tabActive: 0,
      features: [
        {
          id: 0,
          feature: "Lacak",
        },
        {
          id: 1,
          feature: "Cek tarif",
        },
        {
          id: 2,
          feature: "Lokasi agen",
        },
      ]
    }
  },
  mounted() {
    const hashMount = this.$route.hash.replaceAll('#', '').replaceAll('_', ' ');
    hashMount ? this.tabActive = this.features.find(o => o.feature === hashMount.replace(/^./, hashMount[0].toUpperCase())).id : this.tabActive = 0;
  },
  methods: {
    changeTab(id) {
      this.tabActive = id;
      let hash = this.features[id].feature.toLowerCase().replaceAll(' ', '_');
      this.$router.replace({ path: '', query: { ...this.$route.query }, hash: `#${hash}` });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/style.scss";

.base-feature {
  display: flex;
  justify-content: center;

  &__container {
    position: absolute;
    z-index: 2;
    bottom: 5%;
    min-width: 1200px;
    max-width: 1200px;
    width: 1200px;
    min-height: 190px;
    background-color: white;
    border-radius: 24px;
    box-shadow: 0px 15px 25px 0px $color-shadow;

    @include for-size(mobile) {
      bottom: 2%;
      min-width: unset;
      max-width: unset;
      width: 93.5%;
      min-height: 215px;
    }

    @include for-size(mobile-landscape) {
      bottom: 2%;
      min-width: unset;
      max-width: unset;
      width: 93.5%;
      min-height: 215px;
    }

    @media (min-width: 916px) and (max-width: 1023px) {
      bottom: 5%;
      min-width: unset;
      max-width: unset;
      width: 60%;
      min-height: 215px;
    }

    @include for-size(tablet-portrait) {
      bottom: 5%;
      min-width: unset;
      max-width: unset;
      width: 80%;
      min-height: 215px;
    }

    @include for-size(tablet-landscape-new) {
      bottom: 5%;
      min-width: unset;
      max-width: unset;
      width: 70%;
      min-height: 215px;
    }

    @media (min-width: 690px) and (max-width: 690px) {
      bottom: 5%;
      min-width: unset;
      max-width: unset;
      width: 60%;
      min-height: 215px;
    }

    &__head {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      
      &__tabs {
        display: flex;
        justify-content: center;
        cursor: pointer;
        border-bottom: 1px solid $color-border-primary;
        width: 100%;

        &__tab {
          width: calc(100%/3);
          padding: 12px;

          &.active0 {
            background-color: black;
            border-radius: 24px 0 12px 0;
          }

          &.active1 {
            background-color: black;
            border-radius: 0 0 12px 12px;
          }

          &.active2 {
            background-color: black;
            border-radius: 0 24px 0 12px;
          }

          &__title {
            display: flex;
            justify-content: center;
            font-weight: 700;
            font-size: 20px;
            line-height: 48px;
            color: $color-indigo-dark;

            @include for-size(mobile) {
              font-weight: 600;
              font-size: 14px;
              line-height: 24px;
            }

            &.active {
              color: white;
            }
          }
        }

        &__tab:nth-child(1):hover {
          background-color: black;
          border-radius: 24px 0 12px 0;
          
          div {
            color: white !important;
          }
        }

        &__tab:nth-child(2):hover {
          background-color: black;
          border-radius: 0 0 12px 12px;

          div {
            color: white !important;
          }
        }

        &__tab:nth-child(3):hover {
          background-color: black;
          border-radius: 0 24px 0 12px;

          div {
            color: white !important;
          }
        }
      }
    }
  }
}
</style>
